/*--------------------------------------------------------------------------------------------
Program     :  RightSidebar.js
Description :  Main program for Map and Track RightSide data process
Date        :  29/08/2024 
Created By  :  Fode/Jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
29082024        - Fode/Jelbin     -  29/08/2024        Created
---------------------------------------------------------------------------------------------*/
import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Stack, Tooltip, Typography, TextField, Box } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import Fab from '@mui/material/Fab';
import InputLabel from "@mui/material/InputLabel";
import Avatar from '@mui/material/Avatar';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import MainService from "../service/MainService";
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import TimeCalculationService from '../service/TimeCalculationService';
import { useMapTrackInfo } from "../context/Maptrackcontext";
import ParticipantsDialog from './ParticipantsDialog';
import PoiwarningDialog from "./PoiwarningDialog";
import HolidayDialog from "./HolidayDialog";
import HolidayWrngDialog from './HolidayWrngDialog';
import ReportIcon from '@mui/icons-material/Report';
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard';
import PayloadCompare from './PayloadCompare';
import CalculateTrvlTime from './CalculateTrvlTime';


const RightSidebar = ({ selectedtraveler, selectedSourceMain, dayCapacityValue, selectedDate,
    durationFields, messageFields, mapVisibilityDate, ZDATERANGE, tskTravelTimeField,
    tableUniqueName, fieldPOIsave, startTimeField, endTimeField, fielduserstartTime,
    fixschedulefield, finalTravelTimeData, /* startsave, */
    selectedSourceMapname, subformName, participantsData }) => {
    const [view, setView] = useState('byDate');
    const [selectedUser, setSelectedUser] = useState('');
    const [dateView, setDateView] = useState({});
    const [durationFieldsY, setdurationFieldsY] = useState('');
    const { enqueueSnackbar } = useSnackbar()
    const [isProcessing, setIsProcessing] = useState(false);
    const [expandedStates, setExpandedStates] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [showPOIDialog, setShowPOIDialog] = useState(false);
    const [showHolidayDialog, setShowHolidayDialog] = useState(false);
    const [showHolidayWrngDialog, setShowHolidayWrngDialog] = useState(false);
    const [dragResult, setDragResult] = useState({});
    const { dataModified, setDataModified, selectedChooseData, setSelectedChooseData,
        combinedData, setCombinedData, timeATPOI, setNoteLocalSave, setPOIData,
        setResearch, participantsFields, travelerName, participantsTimeFields,
        mergeparticipantFields, startsave, participantTaskTime, setParticipantTaskTime,
        holidayPayload, setFinalTravelTimeData, savedata, setSaveData,
        fielduserHide, basePayload, startTrvlTimeCalculte, setStartTrvlTimeCalculte,
        startPayloadCompare, setStartPayloadCompare,comparedPayload, 
        setComparedPayload,setbasePayload,setTravelTimeLoader,
        travelbuttonEnable,setTravelbuttonEnable,userReadOnly,
        savebuttonEnable,setSavebuttonEnable,agentColor, setagentColor } = useMapTrackInfo();
        
    useEffect(() => {
        if (durationFields.length !== 0) {
            setdurationFieldsY(durationFields[0].NAME);
        }
    }, [durationFields])

    const MAX_HOURS = parseInt(dayCapacityValue.split(':')[0], 10);
    const LoadingOverlay = () => (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            cursor: 'not-allowed'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
                <CircularProgress size={40} />
                <div>Processing task reassignment...</div>
            </div>
        </div>
    );

    useEffect(() => {
        if (view === 'byUser' && selectedUser) {
            const user = combinedData.find(u => u[selectedtraveler] === selectedUser);
            if (user) {
                const dateViewData = user.details.reduce((acc, dataitem) => {
                    const date = dataitem.CREATEDDATE || 'Unknown Date';
                    if (!acc[date]) {
                        acc[date] = [];
                    }
                    acc[date].push(dataitem);
                    return acc;
                }, {});
                setDateView(dateViewData);
            } else {
                setDateView({});
            }
        } else if (view === 'byDate' && selectedDate) {
            const dateViewData = combinedData.reduce((acc, agent) => {
                const filteredDetails = agent.details.filter(detail => detail.CREATEDDATE === selectedDate);
                if (filteredDetails.length > 0) {
                    acc[agent[selectedtraveler]] = filteredDetails;
                }
                return acc;
            }, {});
            setDateView(dateViewData);
        } else {
            setDateView({});
        }
    }, [view, selectedUser, combinedData, selectedtraveler, selectedDate]);

    const UserProgressBar = ({ agent, selectedtraveler }) => {
        var totalTime = 0;
        const isDetailExist = agent.details.filter((data) => data[ZDATERANGE].startsWith(mapVisibilityDate));
        if (isDetailExist.length !== 0) {
            totalTime = agent.totalTime || 0;
        }
        else {
            totalTime = 0;
        }
        const isOvertime = totalTime > MAX_HOURS;
        const hasTasks = agent.details && agent.details.length > 0;
        const calculateWidth = (time) => `${(time / MAX_HOURS) * 100}%`;
        return (
            <div style={{ marginTop: '8px', marginBottom: '8px' }}>
                {/* div for Schedule */}
                <div style={{ fontWeight: 'bold', marginBottom: '4px', fontSize: '14px' }}>
                    Schedule: {TimeCalculationService.formatTime(totalTime)} / {TimeCalculationService.formatTime(MAX_HOURS)}
                    {isOvertime && (
                        <span style={{ color: '#ef4444', marginLeft: '4px' }}>
                            (Exceeds by {TimeCalculationService.formatTime(totalTime - MAX_HOURS)})
                        </span>
                    )}
                </div>
                {/* New div for participant task time */}
                <div style={{ marginBottom: '4px', fontSize: '14px' }}>
                    {participantTaskTime.map((tasktimevalue, index) => {
                        if (
                            tasktimevalue.USERLOGIN === agent[selectedtraveler] &&
                            tasktimevalue.DATE.startsWith(mapVisibilityDate)
                        ) {
                            return (
                                <div key={index} style={{ color: 'red' }}>
                                    {/*Participant traveltime*/}
                                    <b>Participant for: {tasktimevalue.PARTITASKTIME}</b>
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
                {/*div for progress bar*/}
                <div style={{
                    width: '100%',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '4px',
                    height: '24px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    {hasTasks && (
                        <div style={{
                            width: calculateWidth(totalTime),
                            height: '100%',
                            backgroundColor: agent.color || '#3b82f6',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            position: 'relative'
                        }}>
                            {agent.details.map((task, index) => {
                                if (task[ZDATERANGE].startsWith(mapVisibilityDate)) {
                                    // const previousTasksTime = agent.details.slice(0, index).reduce((acc, t) => acc + TimeCalculationService.parseTime(t[durationFieldsY]) + (t.travelTimeTo || 0), 0);
                                    const previousTasksTime = agent.details.slice(0, index)
                                        .filter(t => t[ZDATERANGE].startsWith(mapVisibilityDate))
                                        .reduce((acc, t) =>
                                            acc + TimeCalculationService.parseTime(t[durationFieldsY]) + (t.travelTimeTo || 0),
                                            0
                                        );
                                    return (
                                        <React.Fragment key={index}>
                                            {task.travelTimeTo !== 0 && (
                                                <div style={{
                                                    width: calculateWidth(task.travelTimeTo),
                                                    height: '100%',
                                                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                                    position: 'absolute',
                                                    left: calculateWidth(previousTasksTime)
                                                }}>
                                                </div>
                                            )}
                                            <div style={{
                                                width: calculateWidth(TimeCalculationService.parseTime(task[durationFieldsY])),
                                                height: '100%',
                                                position: 'absolute',
                                                left: calculateWidth(previousTasksTime + (task.travelTimeTo || 0))
                                            }}></div>
                                        </React.Fragment>
                                    );
                                }
                            })}

                            {getfinalTravelTime(agent.finalTravelTime, agent[selectedtraveler]) > 0 && (
                                <div style={{
                                    width: calculateWidth(getfinalTravelTime(agent.finalTravelTime, agent[selectedtraveler])),
                                    height: '100%',
                                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                    position: 'absolute',
                                    right: 0
                                }}></div>
                            )}
                        </div>
                    )}
                    {isOvertime && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: calculateWidth(totalTime - MAX_HOURS),
                            height: '100%',
                            background: `repeating-linear-gradient(
                                45deg,
                                rgba(239, 68, 68, 0.5),
                                rgba(239, 68, 68, 0.5) 10px,
                                rgba(239, 68, 68, 0.7) 10px,
                                rgba(239, 68, 68, 0.7) 20px
                            )`,
                        }}></div>
                    )}
                </div>
            </div>
        );
    };

    const toggleUserExpanded = (agentCode) => {
        setExpandedStates(prev => ({
            ...prev,
            [agentCode]: !prev[agentCode]
        }));
    };

    const handlePOIDlgYes = () => {
        setShowPOIDialog(false);
        handleProcessonDragEnd(dragResult);
        setDragResult({});
    };

    const handlePOIDlgNo = () => {
        setShowPOIDialog(false);
        setDragResult({});
    };

    const handleHolidayYes = () => {
        setShowHolidayDialog(false);
    }

    const handleHolidayWrngYes = () => {
        setShowHolidayWrngDialog(false);
    }


    // Logic for drag and drop the item from progressbar
    const onDragEnd = async (result) => {

        let agentCode = "";
        let destinationId = result.destination?.droppableId || '';

        if (destinationId.endsWith('-header')) {
            agentCode = destinationId.split('-')[0];
        } else {
            agentCode = destinationId;
        }
        // Check is the destination user is on Holiday or not
        const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(holidayPayload, selectedtraveler, agentCode, mapVisibilityDate);
        if (isUserHoliday) {
            setShowHolidayDialog(true);
            handleProcessonDragEnd(result); // comment if block the assgnemt when user holiday
        }
        else {
            const zselectedtask = combinedData.flatMap(user => user.details).filter(detail => detail[tableUniqueName] === parseInt(result.draggableId));
            if (zselectedtask[0].pointsOfInterest !== undefined) {
                setDragResult(result)
                setShowPOIDialog(true);
            }
            else {
                handleProcessonDragEnd(result);
            }
        }
    }

    const handleProcessonDragEnd = async (result) => {
        // Return early if no destination or already processing
        if (!result.destination || isProcessing) return;
        setIsDragging(true);
        setIsProcessing(true);
        setDataModified(true);
        setTravelbuttonEnable(true);
        setSavebuttonEnable(false);
        try {
            const { source, destination } = result;
            let updatedData = JSON.parse(JSON.stringify(combinedData));

            // Step 1: Find source and destination indices
            const sourceAgentIndex = updatedData.findIndex(agent =>
                agent[selectedtraveler] === source.droppableId ||
                `${agent[selectedtraveler]}-header` === source.droppableId
            );
            const destAgentIndex = updatedData.findIndex(agent =>
                agent[selectedtraveler] === destination.droppableId ||
                `${agent[selectedtraveler]}-header` === destination.droppableId
            );

            if (sourceAgentIndex === -1 || destAgentIndex === -1) {
                throw new Error('Source or destination agent not found');
            }

            // Step 2: Handle the move
            // Remove item from source
            const [movedItem] = updatedData[sourceAgentIndex].details.splice(source.index, 1);

            // Update the moved item with new agent details
            const updatedMovedItem = {
                ...movedItem,
                color: updatedData[destAgentIndex].color,
                participantFinalTrvltime: [],   // clear participantFinalTrvltime block
                [selectedtraveler]: updatedData[destAgentIndex][selectedtraveler],
                recordchange: true
            };

            // Insert at destination
            const destIndex = destination.droppableId.endsWith('-header') ? 0 : destination.index;
            if (destination.droppableId.endsWith('-header')) {
                updatedData[destAgentIndex].details.unshift(updatedMovedItem);
            } else {
                updatedData[destAgentIndex].details.splice(destIndex, 0, updatedMovedItem);
            }

            // Add the user participants with the task Only when drag and drop from one user to another differnt user.
            if (sourceAgentIndex !== destAgentIndex) {
                const ZupdatedetailParticipants = TimeCalculationService.handleAddparticipants(updatedData, destAgentIndex,
                    participantsFields, movedItem[tableUniqueName], tableUniqueName);
                updatedData[destAgentIndex].details = ZupdatedetailParticipants;
            }

            // Set destination agent as expanded
            updatedData[destAgentIndex].expanded = true;

            // Step 3: Check and reassign POIs
            TimeCalculationService.reassignuserPOI(updatedData, ZDATERANGE, mapVisibilityDate, selectedtraveler);
            // Loop the payload and make totalTime: 0 if any agent.details.length = 0
            const updatedDataFinal = updatedData.map(agent => {
                // Check if 'details' is empty
                if (agent.details.length === 0) {
                    return {
                        ...agent,
                        totalTime: 0
                    };
                }
                return agent;
            });

            //  Update state back
            setCombinedData(updatedDataFinal);

            // After drag and drop ,Show  the warning message if any of the participant is on absent 
            // for the date under the destiantion user.
            
            const travlerName = destination.droppableId.substring(0, destination.droppableId.lastIndexOf("-"))
            for (const agentblock of updatedDataFinal) {
                if (agentblock[selectedtraveler] === travlerName) {
                    for (const participantblock of agentblock.ZCLA_TEAMMEMBERSR_SUBFORM) {
                        const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(
                            holidayPayload,
                            selectedtraveler,
                            participantblock[selectedtraveler],
                            mapVisibilityDate
                        );
                        if (isUserHoliday) {
                            setShowHolidayWrngDialog(true);
                            break; // exits the inner loop
                        }
                    }
                    break; // exits the outer loop 
                }
            }
        } catch (error) {
            enqueueSnackbar(`Error moving task: ${error.message}`, {
                variant: 'error',
                autoHideDuration: 4000
            });
        } finally {
            setIsProcessing(false);
            setTimeout(() => setIsDragging(false), 500);
        }
    };

    const handleUserChange = (event) => {
        setSelectedUser(event.target.value);
    };

    const handleCalculateTrvlTime = () => {
        setTravelbuttonEnable(false);
        setStartPayloadCompare(true);
        setTravelTimeLoader(true);
    }

    const handlePayloadCompareResult = (payloadresult) => {
        console.log("comparepayload result", payloadresult);
        setComparedPayload(payloadresult);
        setStartPayloadCompare(false);
        setStartTrvlTimeCalculte(true);
    }

    const handleResultTraveltimeCalc = (calcresultPayload) => {
        console.log("handleResulttraveltimeCalc result", calcresultPayload);
        // Update the calcresultPayload with combineddata to view the modifed travel time back to Map&Track
        setCombinedData(calcresultPayload);
        // Reset modified payload with base payload after the recalculation
        setbasePayload(calcresultPayload);
        setComparedPayload([]);
        setStartTrvlTimeCalculte(false);
        setTravelTimeLoader(false);
        setSavebuttonEnable(true);
    }

    const handleSaveData = () => {
        
        // *****NOTE******************************************************
        // The data exists in  **finalTravelTimeData** array  whcih for using in the below tranactions ,
        // is the record saved in the ZMED_FINALTASK FORM. 
        // This data is received during initial page load in Leftsidebar.js. 
        // This data is using for all the data comparison with Lead & Participant

        setSaveData(true);
        setDataModified(false);
        setNoteLocalSave([]);
        const combinedDataChangeOnly = [];
        const resperrors = [];
        const participantFinalTrvltimeCombined = [];
        let   participantsFinlTrvlTimeFinal = [];
        let   leadFinalTravelTimesPayload = [];
        const FinalTravelTimestoDeleteLead = [];
        const FinalTravelTimestoDeleteParticipant = [];

        // Get the list of finalTravelTime record to create/update/delete from ZMED_FINALTASK & CUSTNOTE for TemLeader
        // step1: get the list of user.finalTravelTime from current palyload(leadFinalTravelTimesPayload)
        // Step2: Loop the data throgh finalTravelTimeData and check record exists in  leadFinalTravelTimesPayload.
        // if not exist consider that lead record needs to be deleted(FinalTravelTimestoDeleteLead)
        //=====================================================
        // STEP 1: Collect TeamLeader travel records
        // =====================================================
        for (const user of combinedData) {
            const details = user.details || [];
        
            //Check1: Skip user entirely if no details block
            if (details.length === 0) continue;
        
            const validTravelTimes = [];
            
            // Loop finalTravelTime and check if at least one detail has the same date
            // if no that record will not consider
            for (const travel of user.finalTravelTime || []) {
                if (travel.TRAVLRTYPE !== "TeamLeader") continue;
                const travelDate = travel.TRAVELDATE?.slice(0, 10);
                if (!travelDate) continue;
                // Check2: if at least one detail has the same date
                const matchingDetail = details.some(
                    d => d.CURDATE?.slice(0, 10) === travelDate
                );
                if (matchingDetail) {
                    validTravelTimes.push(travel);
                }
            }
            // Add filtered valid records to final payload
            leadFinalTravelTimesPayload.push(...validTravelTimes);
        }
        console.log("leadFinalTravelTimesPayload:",leadFinalTravelTimesPayload,combinedData);
        //=====================================================================
        // STEP 2: Find TeamLeader records to delete
        // If any record available in finalTravelTimeData and not exist in
        // leadFinalTravelTimesPayload consider that record needs to be deleted
        // ===================================================================
        finalTravelTimeData.forEach(record => {
            if (record.TRAVLRTYPE === "TeamLeader") {
                const exists = leadFinalTravelTimesPayload.some(lead =>
                    lead.TEAMLEADER === record.TEAMLEADER &&
                    lead.TRAVELDATE.slice(0, 10) === record.TRAVELDATE.slice(0, 10) &&
                    lead.TRANSID === record.TRANSID &&
                    lead.TRAVLRTYPE === "TeamLeader"
                );
                if (!exists) {
                    FinalTravelTimestoDeleteLead.push(record);
                }
            }
        });

        console.log("FinalTravelTimestoDelete:",FinalTravelTimestoDeleteLead,
        leadFinalTravelTimesPayload,finalTravelTimeData);

        //=====================================================================
        // STEP 3: Remove unmodifed record from leadFinalTravelTimesPayload.
        // No need to post that again to priority without any change
        // ===================================================================
        leadFinalTravelTimesPayload = leadFinalTravelTimesPayload.filter(lead => {
            const match = finalTravelTimeData.find(
              record =>
                record.TRAVLRTYPE === "TeamLeader" &&
                record.TEAMLEADER === lead.TEAMLEADER &&
                record.TRAVELDATE.slice(0, 10) === lead.TRAVELDATE.slice(0, 10) &&
                record.TRANSID === lead.TRANSID
            );
            //  If record exists and TRAVELTIME is the same, remove it
            if (match && match.TRAVELTIME === lead.TRAVELTIME) {
              return false; // remove this record
            }
          
            //Keep if there's no match or travel time differs
            return true;
          });

        //=====================================================
        // Step4: Collect all participantFinalTrvltime arrays
        // =====================================================
        // Loop through combinedData and get participantFinalTrvltime list in new array
        for (const user of combinedData) {
            for (const detail of user.details || []) {
                // Check if participantFinalTrvltime exists and is an array
                if (detail.participantFinalTrvltime.length !== 0 && Array.isArray(detail.participantFinalTrvltime)) {
                    // Add all items from this participantFinalTrvltime array to our single payload
                    participantFinalTrvltimeCombined.push(...detail.participantFinalTrvltime);
                }
            }
        }
        console.log("participantFinalTrvltimeCombined", participantFinalTrvltimeCombined);
        //=====================================================
        // Step5: Update participantFinalTrvltime with TRANSID
        // =====================================================
        // Loop through participantFinalTrvltimeCombined and update finalTravelTimeData
        // TRANSID into participantFinalTrvltimeCombined for matching record
        for (const participant of participantFinalTrvltimeCombined) {
            const updatedParticipant = { ...participant }; // Create a copy

            // Loop through finatrvltimedata to find a match
            for (const record of finalTravelTimeData) {
                // Check if TRAVELER, TEAMLEADER and TRAVELDATE match
                if (participant.TRAVELER === record.TRAVELER &&
                    participant.TEAMLEADER === record.TEAMLEADER &&
                    participant.TRAVELDATE.slice(0, 10) === record.TRAVELDATE.slice(0, 10) &&
                    participant.TRAVLRTYPE === "Participant") {

                    // Update participant with TRANSID and TRAVELTIME from finatrvltimedata
                    updatedParticipant.TRANSID = record.TRANSID;
                    // Break inner loop since we found the match
                    break;
                }
            }
            participantsFinlTrvlTimeFinal.push(updatedParticipant);
        }
        console.log("participantsFinlTrvlTimeFinal", participantsFinlTrvlTimeFinal);
        //=====================================================
        // Step6: Find Participant records to delete
        // =====================================================
        // Find the participantfinlTRvltime data whcih needs to be deleted from ZMED_FINALTASK & CUSTNOTE
        // Loop throgh finalTravelTimeData and type = "Participant" and if that record not exists in ,
        // participantsFinlTrvlTimeFinal, then that needs to be delete from ZMED_FINALTASK & CUSTNOTE

        finalTravelTimeData.forEach(record => {
            if (record.TRAVLRTYPE === "Participant") {
                const exists = participantsFinlTrvlTimeFinal.some(p =>
                    p.TEAMLEADER === record.TEAMLEADER &&
                    p.TRAVELDATE.slice(0, 10) === record.TRAVELDATE.slice(0, 10) &&
                    p.TRANSID === record.TRANSID &&
                    p.TRAVLRTYPE === "Participant"
                );
                if (!exists) {
                    FinalTravelTimestoDeleteParticipant.push(record);
                }
            }
        });
        console.log("FinalTravelTimestoDeleteParticipant", FinalTravelTimestoDeleteParticipant);

        //=====================================================================
        // STEP 7: Remove unmodifed participant record from participantsFinlTrvlTimeFinal.
        // No need to post that again to priority without any change
        // ===================================================================
        participantsFinlTrvlTimeFinal = participantsFinlTrvlTimeFinal.filter(participant => {
            const match = finalTravelTimeData.find(
              record =>
                record.TRAVLRTYPE === "Participant" &&
                record.TRAVELER === participant.TRAVELER &&
                record.TEAMLEADER === participant.TEAMLEADER &&
                record.TRAVELDATE.slice(0, 10) === participant.TRAVELDATE.slice(0, 10)
            );
          
            // Remove unchanged records 
            if (match && match.TRAVELTIME === participant.TRAVELTIME) {
              return false; // skip this one
            }
          
            //Keep if no match or travel time differs
            return true;
          });

        console.log("participantsFinlTrvlTimeFinal", participantsFinlTrvlTimeFinal);
        
        //=========================================================================
        // Loop through combinedData
        combinedData.forEach((cmpdata) => {
            // Check if there is a POI change in the header level
            if (cmpdata.userPOIChange === true) {
                combinedDataChangeOnly.push(cmpdata);
            }
            else {
                // Check the detail level change and filter the details
                const filteredDetails = cmpdata.details.filter(
                    (detail) => detail.recordchange === true
                );
                if (filteredDetails.length !== 0) {
                    combinedDataChangeOnly.push({ ...cmpdata, details: filteredDetails });
                }
            }
        });
        // Check is there any single record to save from the whole payload
        const changeExist = combinedDataChangeOnly.some(
            item => item.details && item.details.length > 0
          );

        console.log("combinedDataChangeOnly", combinedDataChangeOnly);
        // Call the service only if some record modified
        if (changeExist) {
            // loop through the combinedDataChangeOnly and check is the user is dummy user or not.
            // If user is dummy, then update the task start time and end time to 00:00
            // This change for to stop the STIME error
            // sent the modified payload to service.
            const payloadDataFinal = combinedDataChangeOnly.map((userblock) => {
                if (userblock[fielduserHide] === "Y") {
                    return {
                        ...userblock,
                        details: userblock.details.map((userdata) => ({
                            ...userdata,
                            [startTimeField]: "00:00",
                            [endTimeField]: "00:00",
                        })),
                    };
                }
                return userblock;
            });
            // loop throgh the details block and copy the task travel time value 
            // to task travel time back up field.This is for travel time  issue debugging
            const tsktrvlTimeFldBkup = 'ZMED_TSKTRVLTIME';
            const finalPayloadforAPI = payloadDataFinal.map((userblock) => {
                return {
                    ...userblock,
                    details: userblock.details.map((userdata) => ({
                        ...userdata,
                        [tsktrvlTimeFldBkup]: userdata[tskTravelTimeField], // copy value from REMINEDTIME
                    })),
                };
            });
            console.log("finalPayloadforAPI", finalPayloadforAPI);
            // ******** POST the data to Priority ******************** // 

            MainService.patchData(finalPayloadforAPI, ZDATERANGE, selectedtraveler,
                tableUniqueName, selectedSourceMain, fieldPOIsave,
                startTimeField, endTimeField, tskTravelTimeField, durationFieldsY,
                selectedSourceMapname, selectedChooseData, subformName, participantsFields,
                participantsTimeFields, tsktrvlTimeFldBkup, leadFinalTravelTimesPayload,
                FinalTravelTimestoDeleteLead, participantsFinlTrvlTimeFinal,
                FinalTravelTimestoDeleteParticipant)
                .then((response) => {
                    response.data.forEach(item => {
                        try {
                            const parsedItem = typeof item === "string" ? JSON.parse(item) : item;
                            if (parsedItem.FORM?.InterfaceErrors?.text) {
                                resperrors.push(parsedItem.FORM.InterfaceErrors.text);
                            }
                            else if (parsedItem.error.code !== "200") {

                                resperrors.push(parsedItem.error.message);
                            }
                        } catch (error) {
                            console.error("Failed to parse item:", item, error);
                        }
                    });
                    if (resperrors.length === 0 || resperrors.length === undefined) {
                        setSaveData(false);
                        setDataModified(false);
                        setSelectedChooseData([]);
                        setCombinedData([]);
                        setPOIData([]);
                        setResearch(true);
                        setSavebuttonEnable(false);
                        enqueueSnackbar(`Successfully Saved.`, { variant: 'success' });
                    } else {
                        setSaveData(false);
                        setDataModified(false);
                        setSelectedChooseData([]);
                        setCombinedData([]);
                        setPOIData([]);
                        setResearch(true);
                        setSavebuttonEnable(false);
                        const errorMessage = `Problem occurred saving data.Please search Again. ${resperrors.join(", ")}`;
                        enqueueSnackbar(errorMessage, { variant: 'error' });
                    }
                })
                .catch((err) => {
                    setSaveData(false);
                    setDataModified(false);
                    setSelectedChooseData([]);
                    setCombinedData([]);
                    setPOIData([]);
                    setResearch(true);
                    setSavebuttonEnable(false);
                    enqueueSnackbar(`Problem occurred saving data.Please search Again`, { variant: 'error' });
                });
        }
    }

    const getfinalTravelTime = (finalTravelTimeDataarray, ZselectedTraveller, Zdetails) => {
        if (Zdetails !== undefined) {
            const recordexists = Zdetails.find(task => task[ZDATERANGE]?.startsWith(mapVisibilityDate));
            if (recordexists) {
                if (finalTravelTimeDataarray.length !== undefined) {
                    const ZfinalTravelTimeData = finalTravelTimeDataarray.filter(data => data.TRAVELER === ZselectedTraveller
                        && data.TRAVELDATE.startsWith(mapVisibilityDate) && data.TRAVLRTYPE === "TeamLeader")
                    if (ZfinalTravelTimeData.length !== 0) {
                        return ZfinalTravelTimeData[0].TRAVELTIME
                    }
                }
            }
        }
    }

    console.log("combinedDataRight", combinedData);
    const renderByDate = () => (
        <div style={{ position: 'relative', height: '100%' }}>
            {isProcessing && <LoadingOverlay />}
            <DragDropContext onDragEnd={onDragEnd}>
                <div style={{ padding: '16px', backgroundColor: '#e5e7eb', height: 'calc(100vh - 80px)', overflowY: 'auto' }}>
                    {combinedData.map((agent, agentindex) => {
                        const agentCode = agent[selectedtraveler];
                        const details = agent.details;
                        const participantList = agent.ZCLA_TEAMMEMBERSR_SUBFORM.map(member => member[selectedtraveler]);
                        // Check the logic for user holiday 
                        const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(holidayPayload, 
                            selectedtraveler, agentCode, mapVisibilityDate);
                        // for (const detail of agent.details) {
                        return (
                            <div key={agentCode} style={{
                                marginBottom: '16px',
                                backgroundColor: 'white',
                                borderRadius: '4px',
                                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                                overflow: 'hidden'
                            }}>
                                <Droppable droppableId={`${agentCode}-header`}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            style={{
                                                padding: '12px',
                                                borderBottom: agent.expanded ? '1px solid #e5e7eb' : 'none'
                                            }}
                                        >
                                            {isUserHoliday ?
                                                <Typography variant="body2" sx={{ color: 'red', fontWeight: 'bold', mt: 0.5 }}>
                                                    Holiday
                                                </Typography>
                                                : <></>}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: agent.color, marginRight: '8px' }}></div>

                                                    <div>
                                                        <strong>{agentCode}</strong>
                                                        {/* Display the user participants name */}
                                                        <Stack direction="row" spacing={1}>
                                                            {participantList.map((participantName, partindex) => {
                                                                const isUserHoliday = TimeCalculationService.handlecheckisUserHoliday(
                                                                    holidayPayload,
                                                                    selectedtraveler,
                                                                    participantName,
                                                                    mapVisibilityDate
                                                                );

                                                                return (
                                                                    <Tooltip title={participantName} arrow key={partindex}>
                                                                        <Box position="relative" width={24} height={24}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    width: 24,
                                                                                    height: 24,
                                                                                    fontSize: 10,
                                                                                    bgcolor: agent.color
                                                                                }}
                                                                            >
                                                                                {TimeCalculationService.formatUsername(participantName)}
                                                                            </Avatar>
                                                                            {isUserHoliday && (
                                                                                <Tooltip title="Absent" sx={{
                                                                                    position: 'absolute',
                                                                                    top: -6,
                                                                                    right: -6,

                                                                                    borderRadius: '50%'
                                                                                }}
                                                                                    arrow key={partindex} >
                                                                                    {/* Display ReportIcon for absent */}
                                                                                    <ReportIcon
                                                                                        fontSize="small"
                                                                                        sx={{
                                                                                            position: 'absolute',
                                                                                            top: -6,
                                                                                            right: -6,
                                                                                            color: 'red',
                                                                                            backgroundColor: 'white',
                                                                                            borderRadius: '50%'
                                                                                        }}
                                                                                    />
                                                                                </Tooltip>
                                                                            )}
                                                                        </Box>
                                                                    </Tooltip>
                                                                );
                                                            })}
                                                        </Stack>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => toggleUserExpanded(agentCode)}
                                                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                                >
                                                    {agent.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                </button>
                                            </div>
                                            {durationFields.length !== 0 ?
                                                <UserProgressBar agent={agent} selectedtraveler={selectedtraveler} />
                                                : <></>}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                                <Droppable droppableId={agentCode}>
                                    {(provided) => (
                                        <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            style={{
                                                padding: '12px',
                                                display: expandedStates[agentCode] ? 'block' : 'none',
                                                minHeight: '1px' // Ensure a minimum height for empty lists
                                            }}
                                        >
                                            {details.map((task, detailindex) => {
                                                // Ensure task and ZUNIQUEFIELD are defined
                                                if (task[ZDATERANGE].startsWith(mapVisibilityDate)) {
                                                    return (
                                                        <Draggable
                                                            key={`${task[tableUniqueName]}-${task[selectedtraveler]}-${detailindex}`}
                                                            draggableId={`${task[tableUniqueName]}`}
                                                            index={detailindex}
                                                            isDragDisabled={isProcessing}
                                                        >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={{
                                                                        marginBottom: '8px',
                                                                        padding: '8px',
                                                                        backgroundColor: '#f3f4f6',
                                                                        borderRadius: '4px',
                                                                        ...provided.draggableProps.style,
                                                                    }}
                                                                >
                                                                    {messageFields.map((msgfield) =>
                                                                        task[msgfield.NAME] ? (
                                                                            <div key={msgfield.NAME}>
                                                                                <strong style={{ fontSize: '0.9em' }}>{msgfield.TITLE}:</strong> {task[msgfield.NAME]}
                                                                            </div>
                                                                        ) : null
                                                                    )}
                                                                    {/* Using the new ParticipantsDialog */}
                                                                    <hr style={{ margin: '12px 0', borderTop: '1px solid #e5e7eb' }} />
                                                                    <ParticipantsDialog
                                                                        selectedtask={task}
                                                                        selectedagentindexval={agentindex}
                                                                        participantsData={participantsData}
                                                                        tableUniqueName={tableUniqueName}
                                                                        tskTravelTimeField={tskTravelTimeField}
                                                                        selectedtraveler={selectedtraveler}
                                                                        mapVisibilityDate={mapVisibilityDate}
                                                                        ZDATERANGE={ZDATERANGE}
                                                                        durationFieldsY={durationFieldsY}
                                                                        fielduserstartTime={fielduserstartTime}
                                                                        startTimeField={startTimeField}
                                                                        endTimeField={endTimeField}
                                                                        fixschedulefield={fixschedulefield}
                                                                        selectedSourceMapname={selectedSourceMapname}
                                                                    />
                                                                </div>

                                                            )}
                                                        </Draggable>
                                                    );
                                                }
                                                return null; // Return null instead of empty fragment for clarity
                                            })}

                                            {provided.placeholder}
                                            {details.length > 0 && (
                                                <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
                                                    <div>Final Travel Time: {getfinalTravelTime(agent.finalTravelTime, agent[selectedtraveler], details)}</div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Droppable>
                            </div>
                        );
                    })}
                </div>
            </DragDropContext>
        </div>
    );

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', position: 'relative' }}>
                {view === 'byUser' && (
                    <FormControl fullWidth style={{ marginTop: '16px' }} disabled={isProcessing}>
                        <InputLabel id="user-select-label">Select User</InputLabel>
                        <Select
                            labelId="user-select-label"
                            id="user-select"
                            value={selectedUser}
                            label="Select User"
                            onChange={handleUserChange}
                        >
                            {combinedData.map(agent => (
                                <MenuItem key={agent[selectedtraveler]} value={agent[selectedtraveler]}>
                                    {agent[selectedtraveler]} - {agent.AGENTNAME}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                {/* </div> */}
                <div style={{ flexGrow: 1, height: '100%', overflowY: 'hidden' }}>
                    {renderByDate()}
                </div>
                {userReadOnly !== "Y" ?
                <div
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                    }}
                >
                    <Tooltip title="Calculate Trvl Time" placement="top">
                        <Fab
                            color="secondary"
                            aria-label="calculate"
                            disabled={!travelbuttonEnable}
                            onClick={handleCalculateTrvlTime}
                        >
                            <DepartureBoardIcon />
                        </Fab>
                    </Tooltip>
                    <Tooltip title="Save" placement="top">
                        <Fab
                            color="secondary"
                            aria-label="save"
                            //disabled={combinedData.length === 0 || isProcessing || startsave || !dataModified || travelbuttonEnable}
                            disabled={!savebuttonEnable}
                            onClick={handleSaveData}
                        >
                            <SaveIcon />
                        </Fab>
                    </Tooltip>
                </div> :<></>}
                {/* {savedata ? (
                    <div>
                        Saving Data...
                        <CircularProgress size={25} style={{ color: "red" }} /> 
                    </div>
                ) : null} */}
            </div>
            {showPOIDialog && (
                <PoiwarningDialog
                    dlgPoiWarning={showPOIDialog}
                    handlePOIDlgYes={handlePOIDlgYes}
                    handlePOIDlgNo={handlePOIDlgNo}
                />
            )}
            {showHolidayDialog && <HolidayDialog
                dlgHoliday={showHolidayDialog}
                handleHolidayYes={handleHolidayYes} />}
            {showHolidayWrngDialog && <HolidayWrngDialog
                dlgHolidayWrng={showHolidayWrngDialog}
                handleHolidayWrngYes={handleHolidayWrngYes} />}
            {startPayloadCompare && (
                <PayloadCompare
                    basePayload={basePayload}
                    combinedData={combinedData}
                    ZDATERANGE={ZDATERANGE}
                    tableUniqueName={tableUniqueName}
                    mergeparticipantFields={mergeparticipantFields}
                    selectedtraveler={selectedtraveler}
                    handlePayloadCompareResult={handlePayloadCompareResult} 
                />
            )}
            {startTrvlTimeCalculte && (
                <CalculateTrvlTime
                comparedPayload={comparedPayload}
                handleResultTraveltimeCalc={handleResultTraveltimeCalc}
                // Dynamic field  list
                durationFieldsY={durationFieldsY}
                tskTravelTimeField={tskTravelTimeField}
                selectedtraveler={selectedtraveler}
                ZDATERANGE={ZDATERANGE}
                timeATPOI = {timeATPOI}
                selectedSourceMapname={selectedSourceMapname}
                startTimeField={startTimeField}
                endTimeField={endTimeField}
                fixschedulefield={fixschedulefield}
                fielduserstartTime={fielduserstartTime}
                participantsData={participantsData}
                mergeparticipantFields={mergeparticipantFields}
                />
            )}
        </>
    );

};

export default RightSidebar;